
import ImgToPdf from "../components/ImgToPdf";
import Unipage from "../templates/Unipage";


export default function Widget() {
	return (
		<Unipage
			content={
				<>
					
					<h1>Convert Images to PDF</h1>
					<div className="row m-0 p-0">
						<div className="col-12 p-0 mx-auto">
							<ImgToPdf
								accept={
									{ "image/*": [] }
								}
								height="7.5em" color="black" bgColor="whitesmoke" />
						</div>
					</div>
				</>
			}
		/>
	);
}